/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

function getTargetElm(elm) {
  if (elm) {
    var targetElement = null;

    if (typeof elm === "string") {
      targetElement = document.querySelector(elm);
    } else if (typeof elm === "function") {
      targetElement = elm();
    } else {
      throw new Error("elm should be string or function");
    }

    if (targetElement) {
      return targetElement;
    }

    throw new Error("There is no element with given.");
  } else {
    return document.body;
  }
}

export { getTargetElm as default };
//# sourceMappingURL=getTargetElm.mjs.map
